module.exports = __webpack_public_path__ + "img/new-ranks-element.8d634656.png";